import { render } from "./WhatsAppMessage.vue?vue&type=template&id=6337cc63"
import script from "./WhatsAppMessage.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__